import { ACTIVE_CLASS_NAME, TOOLTIP_ITEM } from '../classnames/tooltip';
import isMobileBrowser from '../utils/isMobileBrowser';

const TOOLTIP_HIDE_DELAY = 200;

export default class Tooltip {
  constructor() {
    this.tooltips = document.querySelectorAll(`.${TOOLTIP_ITEM}`);
    this.isTooltipHovered = false;
  }

  handleHover = (id) => {
    const tooltip = this.element(id);

    tooltip.classList.add(ACTIVE_CLASS_NAME);

    if (!isMobileBrowser()) {
      tooltip.addEventListener('mouseenter', () => this.isTooltipHovered = true);
      tooltip.addEventListener('mouseleave', () => {
        setTimeout(() => {
          this.isTooltipHovered = false;
          tooltip.classList.remove(ACTIVE_CLASS_NAME);
        }, TOOLTIP_HIDE_DELAY);
      });
    }
  };

  handleTouchstart = (id) => {
    const tooltip = this.element(id);

    if (tooltip.classList.contains(ACTIVE_CLASS_NAME)) {
      tooltip.classList.remove(ACTIVE_CLASS_NAME);
    } else {
      tooltip.classList.add(ACTIVE_CLASS_NAME);
    }
  };

  handleGlobalTouchstart = (e, id) => {
    const isActiveTooltip = e.target.classList.contains(ACTIVE_CLASS_NAME);
    const isLink = e.target.parentNode.classList.contains(ACTIVE_CLASS_NAME);
    const isTooltipIcon = e.target.dataset?.icon === 'question';

    if (!isActiveTooltip && !isTooltipIcon && !isLink) {
      this.hide(id);
    }
  };

  hide = (id) => {
    const tooltip = this.element(id);

    setTimeout(() => {
      if (!this.isTooltipHovered) {
        tooltip.classList.remove(ACTIVE_CLASS_NAME);
      }
    }, TOOLTIP_HIDE_DELAY);
  };

  element = (id) => document.getElementById(id);

  initializeEventListeners = () => {
    [...this.tooltips].forEach((tooltip) => {
      const { tooltipId } = tooltip.dataset;

      if (isMobileBrowser()) {
        tooltip.addEventListener('touchstart', () => this.handleTouchstart(tooltipId), { passive: true });
        document.addEventListener('touchstart', (e) => this.handleGlobalTouchstart(e, tooltipId), { passive: true });
      } else {
        tooltip.addEventListener('mouseenter', () => this.handleHover(tooltipId));
        tooltip.addEventListener('mouseleave', () => this.hide(tooltipId));
      }
    });
  };
}
